import Head from 'next/head'
import { useRouter } from 'next/router'
import { Row, Col, Image } from 'antd'
import { useDispatch } from 'react-redux'
import { setDashboardTitle } from '../../../redux/themeSlice'
import { useGetBundlesQuery } from '../../../features/deals/apis/dealsApi'

import Loading from '../../../components/shared-components/Loading'
import Layout from '../../../components/layout-components/dashboardLayout/Layout'
import { useEffect } from 'react'
import { getDashboardPackageRoute } from '@/utils/packageRoutes'

const Pacchetti = () => {
  const { push } = useRouter()
  const dispatch = useDispatch()
  
  useEffect(() => {
    dispatch(setDashboardTitle('Pacchetti'))
  }, [dispatch])

  const { isLoading: isBundlesLoading, data: bundlesData } =
    useGetBundlesQuery()

  if (isBundlesLoading) return <Loading />

  return (
    <>
      <Head>
        <title>Smartcaf | Pacchetti</title>
        <meta
          name='description'
          content='Evita le code, siamo il primo CAF in Italia completamente online!'
        />
      </Head>

      <div className='px-16 md:px-34 py-16 md:py-32'>
        <Row gutter={[24, 24]}>
          {bundlesData?.map((bundle) => (
            <Col key={bundle.id} className='w-full sm:w-auto'>
              <div
                className='text-center shadow-lg rounded-lg p-32 w-full sm:w-[16.5rem] h-full relative cursor-pointer'
                onClick={() => push(getDashboardPackageRoute(bundle.slug))}
              >
                <div className='flex sm:flex-col items-center sm:justify-end gap-12 h-full'>
                  <div className='bg-green_100 rounded-lg w-80 h-80 flex items-center justify-center'>
                    <Image
                      src={`${process.env.NEXT_PUBLIC_IMG_PATH}${bundle.icon}`}
                      alt={bundle.title}
                      preview={false}
                    />
                  </div>
                  <h4 className='text-base font-bold sm:mt-24 mb-0'>
                    {bundle.title}
                  </h4>
                </div>
                <span className='bg-green text-white text-xs font-bold rounded-md py-4 px-8 absolute top-16 right-16'>
                  Nuovo
                </span>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </>
  )
}

Pacchetti.Layout = Layout
export default Pacchetti
